import { useQuery } from '@tanstack/react-query';
import { listingsApi } from "@/lib/api/listings-api";
import { ListingCore, ListingsResponse } from '@/lib/types';

const getPropertyListings = async (): Promise<ListingCore[]> => {
    let allListings: ListingCore[] = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
        const result = await listingsApi.getListings({ page, pageSize: 100 });

        let listings: ListingCore[] = [];
        let meta;

        if (result && Array.isArray(result.data)) {
            listings = result.data;
            meta = result.meta;
        } else if (result && result.data && Array.isArray(result.data.properties)) {
            listings = result.data.properties;
            meta = result.data.pagination;
        } else {
            const directResponse = result as unknown as ListingsResponse;
            if (directResponse && Array.isArray(directResponse.properties)) {
                listings = directResponse.properties;
                meta = directResponse.pagination;
            }
        }

        if (listings.length > 0) {
            allListings = [...allListings, ...listings];
        }

        if (meta && meta.currentPage < meta.totalPages) {
            page++;
        } else {
            hasMore = false;
        }
    }

    if (allListings.length === 0) {
        console.error("No listings found after fetching all pages.");
    }
    
    return allListings;
};

export const usePropertyListings = () => {
  return useQuery<ListingCore[], Error>({
    queryKey: ['propertyListings'],
    queryFn: getPropertyListings,
  });
};
